import React from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';
import { Button, FormControl, Grid } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import { FormField } from '@iris-platform/iris-react-ui';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Call from '@material-ui/icons/Call';
import { toString, concat } from 'ramda';
import Panel from '../Panel';
import NtmTrace from './NtmTrace';
import DateFilter from './DateFilterCard';
import { GET_NTM_DETAILS } from './queries';
import DataProcessor from './dataprocessor';

const styles = theme => ({
  root: {
    opacity: '1',
    backgroundColor: '#fff',
    marginTop: '0 !important',
    border: '1px solid #ccc',
    '&:focus-within': {
      border: '1px solid #66afe9',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  panelHeader: {
    position: 'relative',
  },
  title: {
    display: 'block',
  },
  btn: {
    marginTop: '20px',
  },
  formControl: {
    margin: theme.spacing.unit,
    width: '100%',
    flexDirection: 'row',
    fontSize: '14px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
  },
  formFieldWrapper: {
    width: 350,
    display: 'inline-block',
    margin: '0 10px',
  },
  searchBtn: {
    width: 200,
    textAlign: 'center',
    marginLeft: '30px',
    marginTop: '-8px',
  },
  healthIndicesWrapper: {
    margin: '10px 5px',
    textAlign: 'right',
  },

  selectDropdown: {
    display: 'inline-block',
    width: 350,
    margin: '0 10px',
  },
  search: {
    padding: 0,
  },
  searchIcon: {
    top: '10px',
    right: '4px',
    color: '#ccc',
  },
  searchInput: {
    border: '1px solid #ccc',
  },
  iconStyles: {
    fill: '#1682bc',
  },
});


class NtmTraceData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      traceId: '',
      ntmDetailsData: [],
      searchDone: false,
      traceEntered: false,
      isRegex: false,
    };
  }

  compress = (pn) => {
    const regex = /[-(). ]/g;
    return pn.replace(regex, '');
  }

  onChangeInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  onSearchCalls = async () => {
    const { traceId, isRegex } = this.state;
    const { onSearchNtmEventsByTraceId, searchValues } = this.props;
    const { startTime } = searchValues;
    const { endTime } = searchValues;

    const inpTrace = traceId;
    let searchTraceid = traceId;
    if (isRegex) {
      searchTraceid = concat(concat('/.*', traceId), '.*/');
    }
    this.setState({ traceId: inpTrace });
    onSearchNtmEventsByTraceId(traceId);
    const ntmTraceList = [{ traceId: searchTraceid }];
    const updatedNtmDetailsData = await this.loadNtmDetails(ntmTraceList, startTime, endTime);
    this.setState({ ntmDetailsData: updatedNtmDetailsData, searchDone: true });
  }

  loadNtmDetails = async (ntmTraceList, startTime, endTime) => {
    const { client } = this.props;
    const traceIdList = [];
    Object.keys(ntmTraceList).forEach((idx) => {
      if (ntmTraceList[idx] !== undefined) {
        traceIdList.push(ntmTraceList[idx].traceId);
      }
    });
    let result = [];
    try {
      const ntmDetails = await client.query({
        query: GET_NTM_DETAILS,
        fetchPolicy: 'network-only',
        variables: {
          startTime: toString(startTime),
          endTime: toString(endTime),
          traceIds: traceIdList,
        },
      });
      result = ntmDetails.data.getNtmTraceDetails;
    } catch (error) {
      console.error(error);
    }
    return result;
  }

  handleChangeRB = key => (event, value) => {
    this.setState({
      [key]: value,
    });
  };

  handleChangeCB = name => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  render() {
    const { props } = this;
    const { classes } = props;
    const {
      traceId,
      ntmDetailsData,
      searchDone,
      traceEntered,
      isRegex,
    } = this.state;
    return (
      <Panel
        id="ntmDetailsReport"
        title={(
          <div className={classes.panelHeader}>
            NTM Trace Report
            <DateFilter onClickDateFilter={props.onClickDateFilter} />
          </div>
        )}
        classes={{ title: classes.title }}
        avatar={<Call className={classes.iconStyles} />}
      >
        <FormControl className={classes.formControl}>
          <FormControlLabel
            control={(
              <Checkbox
                checked={isRegex}
                onChange={this.handleChangeCB('isRegex')}
                value="isRegex"
              />
            )}
            label="RegEx"
          />
          <FormField
            placeholder="Enter Trace Id to search"
            id="trace"
            name="traceId"
            classes={{ root: classes.root, formFieldWrapper: classes.formFieldWrapper }}
            className={classes.searchBox}
            value={traceId}
            onChange={(event) => {
              this.onChangeInput(event);
              this.setState({ traceEntered: true });
            }}
          />
          <Button
            className={classes.searchBtn}
            disabled={!traceEntered}
            onClick={this.onSearchCalls}
          >
            Search
          </Button>
        </FormControl>
        <Grid item xs={12}>
          <NtmTrace
            ntmDetailsData={ntmDetailsData}
            searchDone={searchDone}
          />
        </Grid>
      </Panel>
    );
  }
}

NtmTraceData.propTypes = {
  onSearchNtmEventsByTraceId: PropTypes.func.isRequired,
  client: PropTypes.object.isRequired,
};

export default withStyles(styles)(withApollo(NtmTraceData));
